import { IAppConfig, IFieldTypeDefinition, IViewTypeDefinition } from "./DBInterfaces";

export const CONFIG: IAppConfig = {
    MAX_DATA_ROWS: 5000,
    MAX_FIELD_NAME_LENGTH: 32,

    LIST_CARD_WIDTH: 520,
    SIDEBAR_WIDTH: 280,
    TOOLBAR_HEIGHT: 56,

    Z_INDEX: {
        CANVAS: 1,
        RELATIONSHIPS: 11,
        LIST_CARD: 10,
        SELECTED_CARD: 15,
        DRAGGING_CARD: 100,
        TOOLBAR: 1000,
        MODAL: 2000,
        TOAST: 3000
    },

    BREAKPOINTS: {
        MOBILE: 768,
        TABLET: 1024
    },

    DEBOUNCE_DELAY: 16,
    RELATIONSHIP_DRAW_DELAY: 100,
    TOAST_DURATION: 3000,
    ERROR_HIGHLIGHT_DURATION: 2000,

    DEFAULT_APP_CODE: "TC",
    DEFAULT_LIST_POSITION: { X: 40, Y: 40 },
    POSITION_OFFSET: 30,

    COLLAPSED_CARD_WIDTH: 250,
    ARRANGE_GAP_X: 80,
    ARRANGE_GAP_Y: 60,
    ARRANGE_OFFSET_X: 40,
    ARRANGE_OFFSET_Y: 40
};

export const FIELD_TYPES: Record<string, IFieldTypeDefinition> = {
    "text": {
        Icon: "T",
        CssClass: "type-text",
        Label: "Text",
        Description: "Short text input (max 255 characters)"
    },
    "number": {
        Icon: "#",
        CssClass: "type-number",
        Label: "Number",
        Description: "Decimal number"
    },
    "integer": {
        Icon: "1",
        CssClass: "type-integer",
        Label: "Integer",
        Description: "Whole number"
    },
    "currency": {
        Icon: "\u00A3",
        CssClass: "type-currency",
        Label: "Currency",
        Description: "Monetary value"
    },
    "boolean": {
        Icon: "\u2713",
        CssClass: "type-boolean",
        Label: "Yes/No",
        Description: "Boolean true/false"
    },
    "date-time": {
        Icon: "\uD83D\uDCC5",
        CssClass: "type-date",
        Label: "Date & Time",
        Description: "Date and time picker"
    },
    "choice": {
        Icon: "\u2630",
        CssClass: "type-choice",
        Label: "Choice",
        Description: "Single choice dropdown"
    },
    "multi-choice": {
        Icon: "\u2637",
        CssClass: "type-choice",
        Label: "Multi Choice",
        Description: "Multiple choice selection"
    },
    "lookup": {
        Icon: "\uD83D\uDD17",
        CssClass: "type-lookup",
        Label: "Lookup",
        Description: "Reference to another list"
    },
    "url": {
        Icon: "\uD83C\uDF10",
        CssClass: "type-url",
        Label: "Hyperlink",
        Description: "URL or hyperlink"
    },
    "note": {
        Icon: "\uD83D\uDCDD",
        CssClass: "type-text",
        Label: "Note",
        Description: "Multi-line text"
    },
    "rich-text": {
        Icon: "\uD83D\uDCC4",
        CssClass: "type-text",
        Label: "Rich Text",
        Description: "Formatted text"
    },
    "user": {
        Icon: "\uD83D\uDC64",
        CssClass: "type-text",
        Label: "Person",
        Description: "User/person picker"
    },
    "geolocation": {
        Icon: "\uD83D\uDCCD",
        CssClass: "type-url",
        Label: "Geolocation",
        Description: "GPS coordinates (latitude, longitude)"
    }
};

export const VIEW_TYPES: Record<string, IViewTypeDefinition> = {
    "HTML": { Label: "Standard", Icon: "\uD83D\uDCCB", Value: 1 },
    "GRID": { Label: "Datasheet", Icon: "\uD83D\uDCCA", Value: 2048 },
    "CALENDAR": { Label: "Calendar", Icon: "\uD83D\uDCC5", Value: 524288 }
};

export const AGGREGATION_FUNCTIONS: string[] = [
    "COUNT", "SUM", "AVG", "MIN", "MAX", "STD", "VAR"
];
